<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="search" (ngModelChange)="queueFilters()" placeholder="Search users by name, email, phone...">
  </mat-form-field>
  <mat-slide-toggle [(ngModel)]="isAdmin" (ngModelChange)="queueFilters()">Admin</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="isDemo" (ngModelChange)="queueFilters()">Demo</mat-slide-toggle>
  <mat-form-field appearance="outline" class="brand">
    <mat-label>Brand</mat-label>
    <mat-select [(ngModel)]="selectedBrand" (ngModelChange)="queueFilters()">
      <mat-option value="">All Brands</mat-option>
      <mat-option *ngFor="let brand of brandList" [value]="brand.partnerId">{{brand.name}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="filter-actions">
    <button mat-stroked-button color="primary" (click)="clearFilters()">Clear</button>
  </div>
</div>

<div class="bulk-actions">
  <button mat-raised-button color="warn" [disabled]="showDeletedList || removeList.length === 0" (click)="removeUsers()">Remove Checked Users</button>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>Remove?</th>
      <td mat-cell *matCellDef="let user" (click)="stopRowClick($event)">
        <mat-checkbox
          [disabled]="showDeletedList"
          [checked]="isMarkedForRemoval(user)"
          (click)="stopRowClick($event)"
          (change)="toggleRemove(user, $event.checked)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let user">{{user.firstName}} {{user.lastName}}</td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef>Brand</th>
      <td mat-cell *matCellDef="let user">
        <div class="brand-cell">
          <img
            *ngIf="user.brandLogoUrl"
            class="brand-logo"
            [src]="user.brandLogoUrl"
            [alt]="getBrandName(user)"
            (error)="onBrandLogoError(user)"
          >
          <span>{{getBrandName(user)}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Phone</th>
      <td mat-cell *matCellDef="let user">
        <div class="contact-cell">
          <span>{{user.phoneNumber || '-'}}</span>
          <mat-icon *ngIf="isPhoneVerified(user)" class="checkicon" matTooltip="Phone number verified">check</mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let user">
        <div class="contact-cell">
          <span>{{user.email || '-'}}</span>
          <mat-icon *ngIf="isEmailVerified(user)" class="checkicon" matTooltip="Email verified">check</mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="profile">
      <th mat-header-cell *matHeaderCellDef>Profile</th>
      <td mat-cell *matCellDef="let user">
        {{user.permissionLevel === 2147483647 ? 'Admin' : (user.permissionLevel === 1 ? 'Child' : 'Parent')}}
        <span *ngIf="user.isDemo">(Demo Mode)</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let user">{{user.createdAt | date:'shortDate'}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let user">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{user: user}" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (click)="userEdit(row)"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading more items...</div>
  <div class="empty" *ngIf="!loading && items.data.length === 0">There are no items to show.</div>
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-user="user">
    <button mat-menu-item (click)="$event.stopPropagation(); userEdit(user)">Modify User Profile</button>
    <button
      *ngIf="canDemoteExactSuperadmin(user)"
      mat-menu-item
      (click)="$event.stopPropagation(); demoteExactSuperadmin(user)"
    >Disable exact superadmin</button>
    <div
      *ngIf="showExactSuperadminApprovalNotice(user)"
      class="global-permission-note"
      (click)="$event.stopPropagation()"
    >Exact superadmin access cannot currently be granted through Team Admin.</div>
    <button mat-menu-item (click)="$event.stopPropagation(); toggleDemo(user)">{{user.isDemo ? 'Disable' : 'Enable'}} demo mode</button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      [matMenuTriggerFor]="brandHistoryMenu"
      [matMenuTriggerData]="{user: user}"
      (click)="$event.stopPropagation()"
    >Brand History</button>
    <button mat-menu-item *ngIf="canSetProductEligibility()" (click)="$event.stopPropagation(); setProductEligibility(user)">Set product eligibility</button>
    <button mat-menu-item (click)="$event.stopPropagation(); openTeamMemberships(user)">Team memberships</button>
    <button mat-menu-item [matMenuTriggerFor]="loginMenu" [matMenuTriggerData]="{user: user}" (click)="$event.stopPropagation()">Log In</button>
    <button mat-menu-item (click)="$event.stopPropagation(); sendMessage(user)">Send Message</button>
    <button mat-menu-item (click)="$event.stopPropagation(); associateCompanyRole(user)">Associate company role</button>
    <button mat-menu-item *ngIf="canManageScopedAccess(user)" (click)="$event.stopPropagation(); manageScopedAccess(user)">Manage scoped access</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="$event.stopPropagation(); adjustDwollaBalance(user)">Adjust Dwolla Balance</button>
    <button mat-menu-item (click)="$event.stopPropagation(); openStripePayments(user)">Stripe Payments</button>
    <button *ngIf="plaidSandboxToolsEnabled" mat-menu-item (click)="$event.stopPropagation(); openPlaidSandboxTools(user)">Plaid Sandbox Tools</button>
  </ng-template>
</mat-menu>

<mat-menu #brandHistoryMenu="matMenu">
  <ng-template matMenuContent let-user="user">
    <div class="brand-history-list">
      <div class="brand-history-empty" *ngIf="getBrandHistory(user).length === 0">
        No brand history
      </div>
      <div class="brand-history-item" *ngFor="let historyItem of getBrandHistory(user)">
        <img
          *ngIf="historyItem.brandLogoUrl"
          class="brand-history-logo"
          [src]="historyItem.brandLogoUrl"
          [alt]="historyItem.brandName"
          (error)="onBrandHistoryLogoError(historyItem)"
        >
        <div class="brand-history-details">
          <span class="brand-history-name">{{historyItem.brandName}}</span>
          <span>Joined {{historyItem.joinedAt | date:'medium'}}</span>
          <span *ngIf="historyItem.leftAt">Left {{historyItem.leftAt | date:'medium'}}</span>
          <span *ngIf="!historyItem.leftAt">Current</span>
        </div>
      </div>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #loginMenu="matMenu">
  <ng-template matMenuContent let-user="user">
    <button mat-menu-item (click)="$event.stopPropagation(); loginUser(user, false)">App Log In</button>
    <button mat-menu-item (click)="$event.stopPropagation(); loginUser(user, true)">App Log In - Developer</button>
    <button mat-menu-item (click)="$event.stopPropagation(); loginTeamAdmin(user, false)">TeamAdmin Log In</button>
    <button mat-menu-item (click)="$event.stopPropagation(); loginTeamAdmin(user, true)">TeamAdmin Log In - Developer</button>
  </ng-template>
</mat-menu>
